module.exports = __webpack_public_path__ + "img/cms_logo.3833e83f.png";